import { z } from 'zod';
/** Whether the actor is an end user (proxied through primary) or a service account. */
export const ResourceGatewayActorKindSchema = z.enum(['user', 'service']);
/** The result of the audited action. */
export const ResourceGatewayOutcomeSchema = z.enum(['allowed', 'denied', 'error']);
export const ResourceGatewayActorSchema = z.object({
    kind: ResourceGatewayActorKindSchema,
    // Not `.uuid()`: user actors are UUIDs, but service accounts are identified by
    // a name, so `id` can't be uniformly UUID-validated.
    id: z.string(),
    organizationIds: z.array(z.uuid()),
});
/**
 * The thing the action was performed on. A discriminated union on `kind` so it
 * stays type-safe as new target shapes are added (e.g. a connection, a feed).
 */
export const ResourceGatewayTargetSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('resource'), resourceKey: z.string(), resourceId: z.string() }),
    z.object({ kind: z.literal('organization'), id: z.string() }),
]);
/**
 * A single audit event as supplied by a call site. The server stamps the id and
 * timestamp on write — callers never provide them.
 */
export const ResourceGatewayAuditEventSchema = z.object({
    actor: ResourceGatewayActorSchema,
    /** Dotted action name, e.g. `resource.read`, `organization.purge`. */
    action: z.string().min(1),
    organizationId: z.uuid(),
    target: ResourceGatewayTargetSchema,
    outcome: ResourceGatewayOutcomeSchema,
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    metadata: z.record(z.string(), z.unknown()).optional(),
});
//# sourceMappingURL=auditEvent.js.map